import * as React from 'react';
import './spinner.css';

const spinner = (props) => {
    if (props.inlineSpinner) {
        return <div className='inlineSpinner'></div>
    }
    else {
        return <section id="loading-screen">
            <div id="loader"></div>
        </section>
    }
}

export default spinner;